import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rKiraGenelBilgi } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<pList, IInputDataStateModel<pList, rKiraGenelBilgi>, rKiraGenelBilgi>(
  ActionSubTypes.API_KIRAGENELBILGI,
  DefaultInputDataStateModel<pList, rKiraGenelBilgi>()
);
